import { Grid, Typography } from '@mui/material';
import img from 'assets/images/hills.jpg';
import { position } from 'stylis';
import HomeIcon from '@mui/icons-material/Home';
import { useMatches } from 'react-router-dom';
function Page({ children, title }) {
  const match = useMatches();

  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            position: 'relative',
            height: 350,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
          }}>
          <img src={img} style={{ objectFit: 'cover' }} />
          <div
            style={{
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              position: 'absolute',
              background:
                'linear-gradient(to left, rgba(0,0,0,0.7), rgba(0,0,0,0))',
            }}
          />

          <Typography
            component={'div'}
            variant="h4"
            style={{
              position: 'absolute',
              color: 'white',
              left: 0,
              right: 0,
              width: '100%',
              top: '50%',
            }}>
            <div className="container">
              {title}
              <Typography
                className="breadcumb"
                component={'div'}
                variant="h6"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  mt: 0.5,
                  ml: '-4px',
                }}>
                <HomeIcon fontSize="0.8rem" />
                {match?.map((item, index) => (
                  <Typography
                    key={index}
                    className=" breadcumb"
                    component={'div'}
                    variant="h6"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}>
                    {index > 0 && '/'}
                    {item.handle.crumb()}
                  </Typography>
                ))}
              </Typography>
            </div>
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sx={{ mt: 10 }}>
        {children}
      </Grid>
    </Grid>
  );
}

export default Page;
